module.exports = __webpack_public_path__ + "static/media/6C.3708c7e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/6C.svg
// module id = 69
// module chunks = 0